import { useState } from 'react';
import { queryDocAPI } from '../API/docQAAPI';
import './docQA.css'

const readFile = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result.split(',')[1]);
    };
    reader.readAsDataURL(file);
  });
};

function DocumentQA() {
  const [file, setFile] = useState(null);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    const imageData = await readFile(uploadedFile);
    setFile(imageData);
  };

  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setAnswer(null);

    if (!file || !question) {
      setError("Please upload a document and enter a question.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        inputs: {
          image: file,
          question: question
        }
      };

      const response = await queryDocAPI(payload);
      if (response.length === 0) {
        setError("No answer found.");
      } else {
        setAnswer(response[0].answer);
      }
    } catch (error) {
      setError("Error querying the document QA API.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="document-qa-container ">
      <h1>Document QA</h1>
      <form onSubmit={handleSubmit}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <textarea
          placeholder="Enter your question here..."
          value={question}
          onChange={handleQuestionChange}
          rows="4"
        />
        <button type="submit" disabled={loading}>
          {loading ? <div className="spinner"></div> : 'Submit'}
        </button>
      </form>
      {error && <p className="error">{error}</p>}
      {answer && (
        <div className="answer">
          <h2>Answer:</h2>
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
}

export default DocumentQA;